class NavigationSelect extends HTMLSelectElement {
  constructor () {
    super()

    this.handleChange = this.handleChange.bind(this)
  }

  connectedCallback () {
    this.addEventListener('change', this.handleChange)
  }

  disconnectedCallback () {
    this.addEventListener('change', this.handleChange)
  }

  handleChange (e) {
    window.location.href = e.target.value
  }
}

customElements.define('navigation-select', NavigationSelect, {
  extends: 'select',
})
